import { render, staticRenderFns } from "./HbIconButton.vue?vue&type=template&id=08bfa7cf&scoped=true"
import script from "./HbIconButton.vue?vue&type=script&lang=js"
export * from "./HbIconButton.vue?vue&type=script&lang=js"
import style0 from "./HbIconButton.vue?vue&type=style&index=0&id=08bfa7cf&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "08bfa7cf",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("D:\\dev\\hubee\\hubee-backoffice-frontend\\node_modules\\vue-hot-reload-api\\dist\\index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('08bfa7cf')) {
      api.createRecord('08bfa7cf', component.options)
    } else {
      api.reload('08bfa7cf', component.options)
    }
    module.hot.accept("./HbIconButton.vue?vue&type=template&id=08bfa7cf&scoped=true", function () {
      api.rerender('08bfa7cf', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/hubee/HbIconButton.vue"
export default component.exports